import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import UserProfileModal from './UserProfileModal';
import { supabase } from '../config/supabaseClient';

export default function ClickableUsername({ user }) {
  const [showProfile, setShowProfile] = useState(false);
  const [completeProfile, setCompleteProfile] = useState(null);

  useEffect(() => {
    const fetchCompleteProfile = async () => {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Error fetching profile:', error);
          return;
        }

        setCompleteProfile({
          name: `${data.first_name} ${data.last_name}`,
          skillLevel: data.skill_level,
          phoneNumber: data.phone_number || null
        });
      } catch (err) {
        console.error('Error:', err);
      }
    };

    if (user.id) {
      fetchCompleteProfile();
    }
  }, [user.id]);

  return (
    <>
      <button
        onClick={() => setShowProfile(true)}
        className="text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
      >
        {user.name}
      </button>

      <UserProfileModal
        user={completeProfile || user}
        show={showProfile}
        onClose={() => setShowProfile(false)}
      />
    </>
  );
}

ClickableUsername.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    skillLevel: PropTypes.string.isRequired,
  }).isRequired,
}; 